import {required} from "vuelidate/lib/validators";

const awsConnection = (t, regionOptions, regionPlaceholder) => (
  {
    rows: [
      {
        blocks: [
          {
            fields: [
              {
                name: 'bucketName',
                type: 'text',
                placeholder: t('settings.connections.bucketName')
              },
              {
                name: 'accessKey',
                type: 'text',
                placeholder: t('settings.connections.accessKey')
              },
              {
                name: 'secretKey',
                type: 'text',
                placeholder: t('settings.connections.secretKey')
              },
              {
                name: 'region',
                label: '',
                type: 'i-dropdown',
                placeholder: regionPlaceholder,
                allowEmpty: false,
                options: regionOptions
              },
            ]
          },
        ]
      }
    ],
    validations: {
      bucketName: {
        required
      },
      accessKey: {
        required
      },
      secretKey: {
        required
      },
      region: {
        required
      },

    },
    errors: {
      bucketName: {
        required: t("settings.connections.bucketNameRequired"),
      },
      accessKey: {
        required: t("settings.connections.accessKeyRequired"),
      },
      secretKey: {
        required: t("settings.connections.secretKeyRequired"),
      },
      region: {
        required: t("settings.connections.regionRequired"),
      },
    }
  })


export {
  awsConnection,
}
